module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "com-model"
  }, [_c('div', {
    staticClass: "top-bar flex  m-b-24"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/index/finance'
      }
    }
  }, [_vm._v("财务管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("发票管理")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tip"
  }, [_vm._v("注意：请核实发票信息是否正确")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "420px",
      "padding-bottom": "35px"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "180px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "发票抬头",
      "prop": "invoiceTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您营业执照上的全称"
    },
    model: {
      value: (_vm.form.invoiceTitle),
      callback: function($$v) {
        _vm.$set(_vm.form, "invoiceTitle", $$v)
      },
      expression: "form.invoiceTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "税务登记证号",
      "prop": "taxNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写15到20位有效纳税人识别号"
    },
    model: {
      value: (_vm.form.taxNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "taxNumber", $$v)
      },
      expression: "form.taxNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开户银行名称",
      "prop": "bankName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您开户许可证上的开户银行"
    },
    model: {
      value: (_vm.form.bankName),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankName", $$v)
      },
      expression: "form.bankName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "基本开户账号",
      "prop": "bankAccountNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您开户许可证上的银行账号"
    },
    model: {
      value: (_vm.form.bankAccountNumber),
      callback: function($$v) {
        _vm.$set(_vm.form, "bankAccountNumber", $$v)
      },
      expression: "form.bankAccountNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册场所地址",
      "prop": "registeredAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您营业执照上的注册地址"
    },
    model: {
      value: (_vm.form.registeredAddress),
      callback: function($$v) {
        _vm.$set(_vm.form, "registeredAddress", $$v)
      },
      expression: "form.registeredAddress"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册固定电话",
      "prop": "registeredTel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您公司有效的联系电话"
    },
    model: {
      value: (_vm.form.registeredTel),
      callback: function($$v) {
        _vm.$set(_vm.form, "registeredTel", $$v)
      },
      expression: "form.registeredTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开票金额",
      "prop": "invoiceAmount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "max": _vm.maxInvoiceAmount,
      "placeholder": "请填写开票金额"
    },
    model: {
      value: (_vm.form.invoiceAmount),
      callback: function($$v) {
        _vm.$set(_vm.form, "invoiceAmount", $$v)
      },
      expression: "form.invoiceAmount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接收手机",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您接收的手机"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "接收邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请填写您接收的邮箱地址"
    },
    model: {
      value: (_vm.form.email),
      callback: function($$v) {
        _vm.$set(_vm.form, "email", $$v)
      },
      expression: "form.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交审核")])])], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64aa19fb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/finance/invoiceInfo.vue
// module id = 884
// module chunks = 1